import React, { useState, useEffect } from "react";
import { Col, Row, Container, Image, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import dashboard_profile_pic from "../assets/images/dashboard_profile_pic.png";
import edit_contact from "../assets/images/edit_contact.png";
import plus_toggle from "../assets/images/plus_toggle.png";
import { Get } from "../Axios/AxiosFunctions";
import JobsCard from "../Components/JobsCard";
import {
  fallBackCompanyCover,
  imageUrl,
  recordsLimit,
  URL,
} from "../Config/apiUrl";
import InfiniteScroll from "react-infinite-scroll-component";
import NullData from "./../Components/NullData";
import BodyLoader from "../Components/BodyLoader";
import NoMoreJobs from "../Components/NoMoreJobs";
const DashboardCompany = ({ setfooterStyle }) => {
  const history = useHistory();
  const user = useSelector((state) => state.authReducer.user);
  const token = useSelector((state) => state.authReducer.access_token);
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  // ------------------------------------- states ------------------------------------
  const [jobsData, setJobsData] = useState([]);
  const [previousOffset, setPreviousOffset] = useState(0);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);
  const [jobPage, setJobPage] = useState(1);
  const [isLoadingMoreJobs, setIsLoadingMoreJobs] = useState(false);
  // ------------------------------------- handlers ------------------------------------
  const getJobs = async () => {
    if (isLoadingMoreJobs) return;

    // check if we really need next API call
    if (jobPage != 1 && previousOffset === jobsData.length) {
      setHasMoreJobs(false);
      return;
    }

    setPreviousOffset((p) => p + jobsData.length);

    const url = URL(`company/my-jobs?limit=${recordsLimit}&page=${jobPage}`);

    setIsLoadingMoreJobs(true);
    const response = await Get(url, token);
    setIsLoadingMoreJobs(false);

    if (response != undefined) {
      setJobPage((p) => p + 1);
      // setPreviousOffset((p) => p + response?.data?.data?.length * 1);
      setHasMoreJobs(true);
      setJobsData((p) => [...p, ...response?.data?.data]);
    }
  };

  // on Load fire effect
  useEffect(() => {
    getJobs();
  }, []);

  // to scroll top up when page refreshed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#F8F8F8",
      }}
    >
      <Container className="small_container">
        <Row>
          <Col
            className="dashboard_banner"
            style={{
              backgroundImage: `url(${imageUrl}${user?.coverPhoto})`,
            }}
          >
            <div className="profile_pic_div">
              <div className="profile_pic_innerdiv">
                <Image
                  className="profile_pic_div-img"
                  src={`${imageUrl}${user?.photo}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = fallBackCompanyCover;
                  }}
                />
              </div>

              <h3 className="whito font-30">{user?.companyName}</h3>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="small_container company_dashboard">
        <Row className="margin-Profile">
          <Col lg={8} md={12} sm={12} className="x">
            <div className="company_box_8">
              <h4 className="font-26">About the company</h4>
              <p>{user?.description}</p>
            </div>

            {/* <div className="company_box_8 mt-4">
              <div className="d-flex j-between a-center">
                <h4 className="font-26 mb-3">Skills</h4>
                <Image src={plus_toggle} />
              </div>
              <div className="d-flex profile_page_tags">
                <p>Welder</p>
                <p>Black smith</p>
                <p>Craftmen</p>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Certificates</h4>
                <Image src={plus_toggle} />
              </div>
              <div className="d-flex profile_page_tags">
                <p>Driving license_B</p>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Education</h4>
                <Image src={plus_toggle} />
              </div>
              <div className="mar-minus badar_battam">
                <p className="black">AAA Cambridge School</p>
                <p className="black">High School</p>
                <p className="black"> O-Levels </p>
                <p className="black"> 2008 </p>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Experience</h4>
                <Image src={plus_toggle} />
              </div>
              <div className="mar-minus ">
                <p className="black">Michael Steel Workshop </p>
                <p className="black">Designation</p>
                <p className="black">Jan 2008 - Present </p>
              </div>
            </div> */}
            <div className="company-card-box">
              <div class="company-jobs-header mt-3">
                <h4 className="font-26">{/* About the company */}</h4>
                <div
                  class="job-navigator-btn"
                  onClick={() => history.push("/JobPost")}
                >
                  Add New Job
                </div>
              </div>
              {/* Map company jobs here :) */}
              {jobsData.length > 0 && (
                <InfiniteScroll
                  className="company-jobs-container"
                  dataLength={jobsData.length}
                  next={getJobs}
                  hasMore={hasMoreJobs}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                  loader={isLoadingMoreJobs && <NullData />}
                >
                  <div className="m-1 d-flex row" >
                  {jobsData.map((job, index) => (
                      <JobsCard data={job} key={job?._id} col={12} cusClass={"col-lg-6 col-sm-12"} />
                      ))}
                      </div>
                </InfiniteScroll>
              )}

              {jobsData.length === 0 && !isLoadingMoreJobs && (
                <p>
                  <NoMoreJobs text={"No Job to show!"} />
                </p>
              )}
              {isLoadingMoreJobs && <NullData />}
            </div>
          </Col>

          <Col lg={4} md={12} sm={12} style={{ marginTop: 0 }}>
            <div className="details_div_main1">
              <div className="company-follow-container2">
                <h4 className="font-26 mb-4">Details</h4>
                <div
                  class="job-navigator-btn"
                  onClick={() => history.push("/followers")}
                >
                  Click to See Followers
                </div>
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Location</p>
                  <p className="p-20 black detail">{user?.address}</p>
                </div>
                {/* <div>
                  <Image src={edit_contact} />
                </div> */}
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Email Address</p>
                  <p className="p-20 black detail">{user?.UserId?.email}</p>
                </div>
                {/* <div>
                  <Image src={edit_contact} />
                </div> */}
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Phone Number</p>
                  <p className="p-20 black detail">{user?.contactNo}</p>
                </div>
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Contact Person</p>
                  <p className="p-20 black detail">{user?.contactPerson}</p>
                </div>
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>CVR Number</p>
                  <p className="p-20 black detail">{user?.cvrNo}</p>
                </div>
              </div>
            </div>
          </Col>
          {/* <Col lg={12}>
            <Row>
           
            {jobsData.length > 0 && (
              <InfiniteScroll
                className="company-jobs-container"
                dataLength={jobsData.length}
                next={getJobs}
                hasMore={hasMoreJobs}
               
                loader={isLoadingMoreJobs && <NullData />}
              >
                {jobsData.map((job, index) => (
                      <Col lg={3} md={6} sm={12}>
                    <JobsCard data={job} key={job?._id} />
                  </Col>
                ))}
              </InfiniteScroll>
            )}

            {jobsData.length === 0 && !isLoadingMoreJobs && <p><NoMoreJobs/></p>}
            {isLoadingMoreJobs && <NullData />}
            </Row>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default DashboardCompany;
